import React from "react";
import { Route } from "react-router-dom";
import Meta from "../shared/atoms/Meta";

const AuthLayout = ({ children }) => (
  <div>
    <Meta title="SaRa Marketplace - Admin" />
    {children}
  </div>
);

const AuthLayoutRoute = ({ component: Component, ...rest }) => {
  return (
    <React.Fragment>
      <Route
        {...rest}
        render={(matchProps) => (
          <AuthLayout>
            <Component {...matchProps} />
          </AuthLayout>
        )}
      />
    </React.Fragment>
  );
};

export default AuthLayoutRoute;
